import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateInspectionAssessmentRating } from '../services/IpaAssessmentService';
import { iimReviewKeys } from './queryKeys';
/**
 * Overrides the AI inspection assessment rating. Refetches the assessment and bucket counts when settled.
 */
export function useOverrideInspectionAssessment({ inspectionId, assessmentId }) {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => updateInspectionAssessmentRating(assessmentId, params),
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: iimReviewKeys.inspectionAssessment(inspectionId) });
            void queryClient.invalidateQueries({ queryKey: iimReviewKeys.bucketCounts(inspectionId) });
        }
    });
}
